import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { SuccessTemplateProps } from '../../../../templates/Success'
import { useDefaultLayoutProps } from '../../../../layouts/DefaultLayout/useProps'
import { selectors } from '../../../../redux'

export const useModifySuccessProps = (): SuccessTemplateProps => {
  const layout = useDefaultLayoutProps()
  const { t } = useTranslation()
  const visitor = useSelector(selectors.app.visitor)

  return useMemo(
    () => ({
      layout,
      titleDescription: {
        title: t('modifySuccess.title', {
          name: `${visitor?.first_name ?? ''} ${visitor?.last_name ?? ''}`.trim(),
        }),
        description: t('modifySuccess.description', { event: visitor?.event?.name ?? '' }),
        isCentered: true,
      },
    }),
    [layout, t, visitor?.event?.name, visitor?.first_name, visitor?.last_name]
  )
}
